(function () {
    var Vue = require('vue');

    if ($('#vue-users').length > 0) {
        var Users = {
            template: '#vue-users-template',
            data() {
                return {
                    checkedCategories: [],
                };
            },
            methods: {
                showCategory(category) {
                    return this.checkedCategories.indexOf(category) > -1;
                },
            },
            mounted() {
                this.checkedCategories = window.App.UserCategories;
            },
        };

        new Vue({
            el: '#vue-users',
            components: {
                users: Users,
            },
        });

        $(document).on('click', '#member-assigned-bookings-toggle', function (e) {
            e.preventDefault();

            let memberId = $(this).data('member-id');

            let row = $(`#member-assigned-bookings-${memberId}`);

            let checkCurrentStatus = row.hasClass('d-none');

            $('.member-assigned-bookings').addClass('d-none');

            if (checkCurrentStatus) {
                row.removeClass('d-none');
            } else {
                row.addClass('d-none');
            }
        });
    }

    if ($('#poa-bookings').length > 0 && $('#zero-value-bookings').length > 0) {
        let poaBookingsCheckbox = document.getElementById('poa-bookings');
        let zeroValueBookingsCheckbox = document.getElementById('zero-value-bookings');

        poaBookingsCheckbox.onchange = () => updateCheckboxes();

        function updateCheckboxes() {
            let config = {
                poaBookingsChecked: poaBookingsCheckbox.checked,
                zeroValueBookingsChecked: zeroValueBookingsCheckbox.checked && poaBookingsCheckbox.checked,
                zeroValueBookingsEnabled: poaBookingsCheckbox.checked,
            };
            zeroValueBookingsCheckbox.checked = config.zeroValueBookingsChecked;
            zeroValueBookingsCheckbox.disabled = !config.zeroValueBookingsEnabled;
        }

        updateCheckboxes();
    }

    // Select allowed location groups
    if ($('#allowed-locations').length) {
        const allLocationsValue = '__all__';

        $(document).on('select2:select', '#allowed-locations', function (e) {
            if (e.params.data.id === allLocationsValue) {
                $(this).val([allLocationsValue]).trigger('change');

                return;
            }

            let selectedValues = ($(this).val() || []).filter(value => value !== allLocationsValue);
            $(this).val(selectedValues).trigger('change');
        });

        $(document).on('select2:unselect', '#allowed-locations', function (e) {
            if (e.params.data.id === allLocationsValue && !($(this).val() || []).length) {
                $(this).trigger('change');
            }
        });

        $(document).on('click', '#select2-allowed-locations-results .select2-results__group', function (e) {
            let allowedLocations = [];
            let allowedLocationsOptions = $(this).parent().children('ul').children('li');
            let allowedLocationsIds = [];
            let uniqueAllowedLocations = [];

            // Keep previous selected values
            if ($('#allowed-locations').val()) {
                allowedLocations = allowedLocations.concat($('#allowed-locations').val());
            }

            allowedLocations = allowedLocations.filter(location => location !== allLocationsValue);

            // Save every option within the group and mark them as selected
            allowedLocationsOptions.each((index, element) => {
                allowedLocationsIds.push(element.id.split('-')[element.id.split('-').length - 1]);
                $(element).attr('aria-selected', true);
            });

            // Unselect everything if the were selected
            if (allowedLocationsIds.every(val => allowedLocations.includes(val))) {
                uniqueAllowedLocations = allowedLocations.filter(function (element, index, self) {
                    return index === self.indexOf(element);
                });

                allowedLocationsOptions.each((index, element) => {
                    $(element).attr('aria-selected', false);

                    uniqueAllowedLocations = uniqueAllowedLocations.filter(
                        location => location != element.id.split('-')[element.id.split('-').length - 1]
                    );
                });
            } else {
                // select not repeated locations
                allowedLocations = allowedLocations.concat(allowedLocationsIds);

                uniqueAllowedLocations = allowedLocations.filter(function (element, index, self) {
                    return index === self.indexOf(element);
                });
            }

            $('#allowed-locations').val(uniqueAllowedLocations);
            $('#allowed-locations').trigger('change');
        });
    }

    document.addEventListener('livewire:init', () => {
        Livewire.on('restricted-vehicles-options-updated', event => {
            const payload = Array.isArray(event) ? event[0] : event;
            const restrictedVehiclesSelect = $('#restricted-vehicles');

            if (!restrictedVehiclesSelect.length) {
                return;
            }

            const options = payload.options || [];
            const selected = payload.selected || [];
            const isSelect2Initialized = restrictedVehiclesSelect.hasClass('select2-hidden-accessible');

            if (isSelect2Initialized) {
                restrictedVehiclesSelect.select2('destroy');
            }

            restrictedVehiclesSelect.empty();

            options.forEach(vehicleCode => {
                const option = new Option(vehicleCode, vehicleCode, false, selected.includes(vehicleCode));
                restrictedVehiclesSelect.append(option);
            });

            restrictedVehiclesSelect.val(selected);

            if (isSelect2Initialized) {
                restrictedVehiclesSelect.select2();
            }

            restrictedVehiclesSelect.trigger('change');
        });
    });
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal/pages/users.js